import { editorLanguage, load } from "scrivito"

import { editorInstance } from "editorI18n"

load(() => editorLanguage()).then(
  lng => lng && editorInstance.changeLanguage(lng)
)

import.meta.glob(
  [
    "./**/*ObjClass.ts",
    "./**/*ObjClass.tsx",
    "./**/*Component.ts",
    "./**/*Component.tsx",
    "!./**/__tests__/*.ts",
    "!./**/__tests__/*.tsx"
  ],
  {
    eager: true
  }
)
